export default "__VITE_ASSET__5b6b03b3__"